import { deleteDoc, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig"; // Ensure Firebase Auth is set up
import { User } from "firebase/auth";
import { Cart } from "../model/CartModel";

export const CartGateway = {
    SaveCart: async (cart: Cart, user: User) => {
        if (!user) return; // Ensure user is authenticated

        const userCartRef = doc(db, "carts", user.uid); // Reference cart document for the user

        try {
            await setDoc(userCartRef, { ...cart, lastUpdated: serverTimestamp() }, { merge: true }); // Save cart with merge to update existing data
            //console.log("Cart successfully updated in Firestore!");
        } catch (error) {
            console.error("Error updating cart:", error);
        }
    },   
    DeleteCart: async (user: User) => {
        const cartRef = doc(db, "carts", user.uid);
        return deleteDoc(cartRef);
    }
};